import { db } from '@/data/firebase/config';
import { DOCUMENTS_DB } from '@/domain/env/documents-db';
import {
  CollectionBase,
  CriticalStandard,
  Newsletter,
  Podcast,
  Report,
} from '@/domain/types/collections';
import FormAddDocument from '@/presentation/components/form-add-document';
import { addDoc, collection, serverTimestamp } from 'firebase/firestore';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

const PodcastAddPage = () => {
  const navigate = useNavigate();

  const handleSave = async (
    data: CollectionBase | Podcast | Newsletter | Report | CriticalStandard,
  ) => {
    try {
      await addDoc(collection(db, DOCUMENTS_DB.PODCASTS), {
        ...data,
        createdAt: serverTimestamp(),
      });
      toast.success('Audio guardado correctamente', {
        theme: 'colored',
      });
      navigate('/dashboard/podcasts');
    } catch (error) {
      toast.error('Error al guardar el audio', {
        theme: 'colored',
      });
      // Re-thrown so FormAddDocument knows the save failed and keeps the
      // autosaved draft instead of deleting the user's only remaining copy.
      throw error;
    }
  };

  return (
    <div className="p-4 flex flex-col gap-4 ">
      <h1 className="text-3xl font-bold">Agregar Audio</h1>
      <FormAddDocument
        onSave={handleSave}
        hasAudio
        hasImage={false}
        hasPdf={false}
        hasVideo={false}
        contentType="podcast"
      />
    </div>
  );
};

export default PodcastAddPage;
